import { render, staticRenderFns } from "./SitesTable.vue?vue&type=template&id=9d8aeb04&scoped=true&"
import script from "./SitesTable.vue?vue&type=script&lang=js&"
export * from "./SitesTable.vue?vue&type=script&lang=js&"
import style0 from "./SitesTable.vue?vue&type=style&index=0&id=9d8aeb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8aeb04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
